var locationViewSelector = document.querySelector('.location-view-selector');
var locationsList = document.querySelector('.locations-list');
var locationsMap = document.querySelector('.locations-map');
if (locationViewSelector) {
  document.querySelector('.location-view-selector .toggle-list')
  .addEventListener('click', function (e) {
    document.querySelector('.location-view-selector .toggle-grid').classList.remove('active');
    document.querySelector('.location-view-selector .toggle-list').classList.add('active');
	locationsList.classList.add('active');
	locationsMap.classList.remove('active');
    e.preventDefault();
});

document.querySelector('.location-view-selector .toggle-grid')
  .addEventListener('click', function (e) {
    document.querySelector('.location-view-selector .toggle-list').classList.remove('active');
    document.querySelector('.location-view-selector .toggle-grid').classList.add('active');
	locationsMap.classList.add('active');
	locationsList.classList.remove('active');
    e.preventDefault();
});
}

// Generate Google Map with markers and info windows
function generateGoogleMap(locationResults) {
  var center = new google.maps.LatLng(locationResults[0][2], locationResults[0][3]);
  var mapOptions = {
    zoom: 9,
    center: center,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  };
  var infowindow = new google.maps.InfoWindow({content: ''});

  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
  for (i = 0; i < locationResults.length; i++) {
    addMarker(locationResults[i]);
  }

  function addMarker(marker) {
    var gmarkers = (typeof gmarkers1 === 'undefined') ? [] : gmarkers1;
    var title = marker[1];
    var address = marker[4];
    var phone = marker[5];
    var url = marker[6];
    var pos = new google.maps.LatLng(marker[2], marker[3]);
    var content = '<div class="map-info-window"><h4>' + title + '</h4>' + '<p>' + address + '</p>' + '<p>' + phone + '</p>' + '<p><a class="card-link" href="' + url + '">Location Details</a></p></div>';

    marker = new google.maps.Marker({
      title: title,
      position: pos,
      map: map,
      icon: '/public/assets/MEEI/svg/icons/background/icon-location-red.svg'
    });

    gmarkers.push(marker);

    google.maps.event.addListener(marker, 'click', (function (marker, content) {
      return function () {
        infowindow.setContent(content);
        infowindow.open(map, marker);
        map.panTo(this.getPosition());
        map.setZoom(10);
      }
    })(marker, content));
  }
}

jQuery(document).ready(function() {
  if (typeof locationResults !== 'undefined') {
    generateGoogleMap(locationResults);
  }
});